<template>
  <v-dialog v-model="displaySuccessDialog" persistent max-width="820" data-qa="confirmdomesticpayment-dialog-9eaoh">
    <v-card data-qa="confirmdomesticpayment-card-9wi27">
      <div v-if="successResponse && successResponse.referenceID" data-qa="confirmdomesticpayment-div-8j1zb9">
        <v-card-title class="justify-center" data-qa="confirmdomesticpayment-card-title-f0mpx">
          <inline-svg
            :src="getTickIcon()"
            width="100"
            height="100"
            aria-label="Tick Icon"
          ></inline-svg>
        </v-card-title>
        <v-spacer data-qa="confirmdomesticpayment-spacer-ne1j99"></v-spacer>
        <v-row
          justify="center"
          class="mx-5 mx-sm-auto mx-md-auto mx-lg-auto mx-xl-auto"
         data-qa="confirmdomesticpayment-row-v0kxse">
          <span class="text-center font-weight-medium" data-qa="confirmdomesticpayment-span-pcc16">
            {{ $t("confirmDomesticPayment.transferSuccess") }} -
            {{ successResponse.referenceID }}
          </span>
        </v-row>
        <v-card-text class="pb-0" data-qa="confirmdomesticpayment-card-text-lzn1c4">
          <v-row no-gutters class="transferfunds--review-content-padding pt-2" data-qa="confirmdomesticpayment-row-dbra2n">
            <DisplayDetails
              :config="{
                title: '',
                dataList: confirmationDetails,
                translation: 'transferfunds'
              }"
              class="pl-10"
            />
          </v-row>
        </v-card-text>
      </div>
      <div v-else data-qa="confirmdomesticpayment-div-cd8lj">
        <v-card-title class="justify-sm-center" data-qa="confirmdomesticpayment-card-title-k43072">
          <v-icon x-large :color="errorColor" class="mt-8"
             data-qa="confirmdomesticpayment-icon-ahynie">mdi-alert-circle-outline</v-icon
          >
        </v-card-title>
        <v-spacer data-qa="confirmdomesticpayment-spacer-s2wpg"></v-spacer>
        <v-card-subtitle class="text-center" data-qa="confirmdomesticpayment-card-subtitle-jfzc08">
          {{ $t("transferfunds.transferFailure") }}
        </v-card-subtitle>
      </div>
      <v-card-actions class="text-center pb-2 mt-8" data-qa="confirmdomesticpayment-card-actions-ap887e">
        <v-layout column justify="center" data-qa="confirmdomesticpayment-layout-c5q93u">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="confirmdomesticpayment-flex-p11ath">
            <v-btn
              @click="newTransferRequest"
              :color="primaryColor"
              :disabled="loaderEnabled"
              elevation="2"
              class="text-capitalize ma-2 white--text py-2 px-4"
             data-qa="confirmdomesticpayment-btn-owujbe">
              {{ $t("transferfunds.makeAnotherTransferButton") }}
            </v-btn>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="confirmdomesticpayment-flex-oi94w">
            <v-btn
              @click="returnToDashboard"
              :color="primaryColor"
              :disabled="loaderEnabled"
              text
              class="text-capitalize ma-2 font-weight-bold py-2 px-4"
             data-qa="confirmdomesticpayment-btn-tv5vds">
              {{ $t("transferfunds.gotoDashboadButton") }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import preload from '@/util/preload'
import event from '@/util/event'
import { getAccountTypeLabel } from '../../../../util/accountUtil'

export default {
  name: 'ConfirmDomesticPayment',
  props: {
    config: Object,
    displaySuccessDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DisplayDetails
  },
  data () {
    return {
      loaderEnabled: false,
      showConfirmationModal: true,
      successDialog: true,
      successResponse: '',
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      confirmationDetails: []
    }
  },
  created () {
    if (this.config && this.config.successResponse.referenceID) {
      this.successResponse = this.config.successResponse
      if (this.successResponse.paymentType === 'UKFPS') {
        event.$emit('is_UKFPS_TransferComplete', true)
      } else if (this.successResponse.paymentType === 'SEPA') {
        event.$emit('is_SEPA_TransferComplete', true)
      }
      this.setConfirmationData()
    }
  },
  methods: {
    async returnToDashboard () {
      await preload.getListOfAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.$router.push('/home')
    },
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    setConfirmationData () {
      this.confirmationDetails = []
      const currentDate = new Date(Date.now()).toISOString().substr(0, 10)
      const isQuickPay = this.$route.params.isQuickPay
      this.confirmationDetails.push(
        {
          label: 'fromLabel',
          value: this.formatDisplayedFromAccount(this.$route.params.fromAccType || this.successResponse.fromAccType)
        },
        {
          label: isQuickPay ? 'toAccIBAN' : 'toLabel',
          value: isQuickPay ? this.successResponse.toAccName : this.successResponse.payeeAccountName,
          subValue: !isQuickPay ? `(${this.successResponse.toAcc})` : `(${this.successResponse.toAcc} | ${this.successResponse.bicCode})`
        },
        {
          label: 'amountLabel',
          value: this.$formatter.currency.format(
            this.successResponse.amt,
            this.successResponse.currency
          )
        },
        {
          label: this.successResponse.paymentType === 'SEPA' ? 'charge' : 'chargeAmountLabel',
          value: this.$formatter.currency.format(
            this.successResponse.chargeAmount,
            this.successResponse.currency
          )
        },
        {
          label: 'quickPaymentDateLabel',
          value: this.$formatter.formatDate(currentDate)
        },
        {
          label: 'reviewNoteLabel',
          value: this.successResponse.transferNote
        }
      )
    },
    newTransferRequest () {
      this.$emit('close')
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
    },
    formatDisplayedFromAccount (accountType) {
      const account = this.enableIBANAccountNumberDisplay
        ? this.successResponse.fromAccIBAN
          ? this.successResponse.fromAccIBAN : this.successResponse.fromAcc
        : this.successResponse.fromAcc
      const label = getAccountTypeLabel(accountType)
      return `${label} - ${account}`
    }
  }
}
</script>
